export const KLOOK_AID  = '120105';
export const TRIP_AID   = '8171962';
export const TRIP_SID   = '309371812';
export const KKDAY_CID  = '24829';
export const STAY22_AID = 'ectravel';
export const RADICAL_STORAGE_AID = '0eede0a5a6ed032f88c40af168b38f73';
export const RADICAL_STORAGE_COUPON = 'ECTRAVEL';

export const AFFILIATE = {
  klook:'https://www.klook.com', kkday:'https://www.kkday.com',
  trip:'https://www.trip.com', booking:'https://www.booking.com',
  agoda:'https://www.agoda.com', airbnb:'https://www.airbnb.com',
  viator:'https://www.viator.com', stay22:'https://www.stay22.com',
};

// Allez's "roam" endpoint picks the best OTA per visitor for a given address —
// works with any place/hotel name, no per-link pre-generation needed.
// 指定單一酒店時要帶 hotelname + lat/lng：只給 address 的話 Stay22 會拿日文名去地理編碼，
// 常落到錯的位置，打開後不是該酒店。座標優先於 address（見 dev.stay22.com/docs/allez/parameters）。
export const stay22Link = (query, { hotelname, lat, lng } = {}) => {
  let url = `https://www.stay22.com/allez/roam?aid=${STAY22_AID}&address=${encodeURIComponent(query || '')}`;
  if (hotelname) url += `&hotelname=${encodeURIComponent(hotelname)}`;
  if (lat != null && lng != null) url += `&lat=${lat}&lng=${lng}`;
  return url;
};

// Radical Storage has no per-city deep link yet (no iframe/API access) —
// this is the flat affiliate link with our coupon code attached, same for every city.
export const radicalStorageLink = () =>
  `https://radicalstorage.com/?acc=${RADICAL_STORAGE_AID}&utm_source=aff_link&utm_medium=${RADICAL_STORAGE_AID}&couponCode=${RADICAL_STORAGE_COUPON}`;

// Saily eSIM affiliate link (TUNE/HasOffers tracking, offer_id 101 / aff_id
// 16700). SAILY_DEEPLINK_TEMPLATE is the exact string TUNE's own "Add Deep
// Link" tool generated for this offer (confirmed in the affiliate dashboard,
// not guessed). Only the "{SLUG}" and "{coupon}" tokens are filled in here;
// the other {macro} placeholders are substituted by TUNE server-side.
export const SAILY_BASE = 'https://go.saily.site/aff_c?offer_id=101&aff_id=16700';
const SAILY_DEEPLINK_TEMPLATE = 'https://go.saily.site/aff_c?offer_id=101&aff_id=16700&url=https%3A%2F%2Fsaily.com%2Fesim-{SLUG}%2F%3Fcoupon%3D{coupon}%26utm_source%3D{aff_id}%26utm_medium%3Daffiliate%26utm_campaign%3D{offer_id}%26aff_transaction_id%3D{transaction_id}%26aff_sub%3D{aff_sub}%26aff_offer_id%3D{offer_id}%26aff_id%3D{aff_id}%26url%3Dhttps://saily.com/esim-{SLUG}/%26utm_content%3D{aff_sub}%26params%5Bho_asub1%5D%3D{aff_sub}';
// Promo code issued by Saily: 10% off (no expiry date provided, so none is shown).
export const SAILY_COUPON = 'TRAVEC10';
// With a country/region slug: that eSIM page. Without: the saily.com home page. Both carry the coupon.
export const sailyLink = (slug) => slug
  ? SAILY_DEEPLINK_TEMPLATE.replace(/\{SLUG\}/g, slug).replace('{coupon}', SAILY_COUPON)
  : `${SAILY_BASE}&url=${encodeURIComponent(`https://saily.com/?coupon=${SAILY_COUPON}`)}`;
export const sailyCouponLabel = (lang) => lang==='en' ? `Promo code ${SAILY_COUPON} — 10% off`
  : lang==='ja' ? `プロモコード ${SAILY_COUPON} — 10%オフ`
  : lang==='ko' ? `프로모션 코드 ${SAILY_COUPON} — 10% 할인`
  : `優惠碼 ${SAILY_COUPON} — 享10%折扣`;

export const KLOOK_CITY = {
  'Hong Kong':'1-hong-kong', 'Tokyo':'2-tokyo', 'Osaka':'3-osaka',
  'Seoul':'11-seoul', 'Bangkok':'5-bangkok', 'Bali':'7-bali',
  'Singapore':'4-singapore', 'Taipei':'17-taipei', 'Kyoto':'40-kyoto',
  'Macau':'13-macau', 'London':'26-london', 'Paris':'55-paris',
};

export const TRIP_CITY = {
  'Hong Kong':'hong-kong', 'Tokyo':'tokyo', 'Osaka':'osaka',
  'Seoul':'seoul', 'Bangkok':'bangkok', 'Bali':'bali',
  'Singapore':'singapore', 'Taipei':'taipei', 'Kyoto':'kyoto',
  'Macau':'macau', 'London':'london', 'Paris':'paris',
};

export const safeHref = (url) => {
  if (!url || url === '#') return '#';
  try {
    const { protocol } = new URL(url);
    return (protocol === 'https:' || protocol === 'http:') ? url : '#';
  } catch { return '#'; }
};

export const getAffiliateLinks = (cityKey) => {
  const klookSlug = KLOOK_CITY[cityKey];
  const tripSlug  = TRIP_CITY[cityKey];
  const kq = encodeURIComponent(cityKey);
  return {
    klook: klookSlug
      ? `https://www.klook.com/en-HK/city/${klookSlug}-things-to-do/?aid=${KLOOK_AID}`
      : `https://www.klook.com/en-HK/search/result/?query=${kq}&aid=${KLOOK_AID}`,
    trip: tripSlug
      ? `https://www.trip.com/travel-guide/${tripSlug}/attraction/?Allianceid=${TRIP_AID}&SID=${TRIP_SID}`
      : `https://www.trip.com/?Allianceid=${TRIP_AID}&SID=${TRIP_SID}`,
    kkday: `https://www.kkday.com/zh-hk/product/search?q=${kq}&cid=${KKDAY_CID}`,
  };
};

export const sanitizeDealLink = (deal) => {
  const q = encodeURIComponent(deal.title || '');
  const platform = (deal.platform || '').toLowerCase();
  const link = deal.link || '';
  if (platform === 'klook' || link.includes('klook.com'))
    return { ...deal, link: `https://www.klook.com/en-HK/search/result/?query=${q}&aid=${KLOOK_AID}` };
  if (platform === 'kkday' || link.includes('kkday.com'))
    return { ...deal, link: `https://www.kkday.com/zh-hk/product/search?q=${q}&cid=${KKDAY_CID}` };
  if (platform === 'trip.com' || link.includes('trip.com'))
    return { ...deal, link: `https://www.trip.com/things-to-do/?query=${q}&Allianceid=${TRIP_AID}&SID=${TRIP_SID}` };
  return deal;
};
